module.exports = __webpack_public_path__ + "static/media/arrow-down-solid.fecc2642.svg";